import { cn } from '@/lib/utils';
import type { BadgeProps, BadgeVariant } from '@/types/components.types';

const VARIANTS: Record<BadgeVariant, string> = {
  default: 'bg-zinc-800 text-zinc-300 border-zinc-700',
  success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  danger:  'bg-red-500/10 text-red-400 border-red-500/20',
  primary: 'bg-violet-500/10 text-violet-400 border-violet-500/20',
  acp:     'bg-blue-500/10 text-blue-400 border-blue-500/20',
  info:    'bg-sky-500/10 text-sky-400 border-sky-500/20',
};

export const Badge = ({ children, variant = 'default', className }: BadgeProps) => (
  <span className={cn(
    'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
    VARIANTS[variant], className,
  )}>
    {children}
  </span>
);
